import React from 'react';
import { MAINTENANCE_CONFIG } from '../config/maintenance';

const MaintenancePage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-green-50 to-brown-50 flex items-center justify-center px-4">
      <div className="max-w-4xl w-full">
        {/* Header */}
        <div className="text-center mb-12">
          <div className="flex justify-center items-center mb-6">
            <div className="w-16 h-16 bg-gradient-green rounded-full flex items-center justify-center">
              <span className="text-white font-bold text-2xl">🕉</span>
            </div>
            <div className="ml-4">
              <h1 className="text-3xl font-bold text-gray-900">
                Sravani <span className="text-brown-600">Ayurdham</span>
              </h1>
            </div>
          </div>
        </div>

        {/* Main Content */}
        <div className="bg-white rounded-2xl shadow-2xl overflow-hidden">
          <div className="bg-gradient-green px-8 py-6">
            <div className="flex items-center justify-center">
              <div className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center mr-4">
                <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
              </div>
              <h2 className="text-2xl md:text-3xl font-bold text-white">
                {MAINTENANCE_CONFIG.maintenanceInfo.title}
              </h2>
            </div>
          </div>

          <div className="p-8 md:p-12">
            {/* Main Message */}
            <div className="text-center mb-8">
              <p className="text-xl text-gray-700 leading-relaxed mb-6">
                {MAINTENANCE_CONFIG.maintenanceInfo.message}
              </p>
            </div>

            {/* Progress Animation */}
            <div className="mb-8">
              <div className="bg-gray-200 rounded-full h-3 overflow-hidden">
                <div className="bg-gradient-green h-full rounded-full animate-pulse" style={{width: '75%'}}></div>
              </div>
              <p className="text-center text-sm text-gray-600 mt-2">Maintenance Progress</p>
            </div>

            {/* Thank You Message */}
            <div className="text-center bg-gradient-to-r from-green-50 to-brown-50 rounded-xl p-6">
              <h3 className="text-xl font-semibold text-gray-900 mb-2">
                Thank You for Your Patience 🙏
              </h3>
              <p className="text-gray-600">
                We're working hard to bring you an even better experience. 
                Your health and wellness journey with us will be enhanced very soon!
              </p>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="text-center mt-8 text-gray-600">
          <p className="text-sm">
            © 2025 Sravani Ayurdham. All rights reserved.
          </p>
        </div>
      </div>
    </div>
  );
};

export default MaintenancePage;
